export const XL = 'xl';
export const XM = 'xm';
export const LG = 'lg';
export const BASE = 'base';
export const MD = 'md';
export const SM = 'sm';
export const XS = 'xs';
export const XSM = 'xsm';
export const XXS = 'xxs';

export type SizesType =
    | typeof XL
    | typeof XM
    | typeof LG
    | typeof BASE
    | typeof MD
    | typeof SM
    | typeof XS
    | typeof XSM
    | typeof XXS;
